import UiUtils from "@/assets/js/ui_utils.js";

export const WALLET_EXCHANGE_CODES = ["xbul", "xetr", "xfra"];

export const WALLET_EXCHANGE_SUMMARY_CONFIG = [
  {
    id: 1,
    code: "xbul",
    title: "Bulgarian Fund Exchange",
    logo: "bfb",
    baseCurrency: "EUR",
    visibleCurrency: "EUR"
  },
  {
    id: 2,
    code: "xetr",
    title: "Deutsche Boerse Xetra",
    baseCurrency: "EUR",
    visibleCurrency: "EUR"
  },
  {
    id: 3,
    code: "xfra",
    title: "Deutsche Boerse Frankfurt",
    baseCurrency: "EUR",
    visibleCurrency: "EUR"
  }
];

function normalize(value) {
  return value?.toString().toLowerCase() || "";
}

export function getExchangeById(exchanges, exchangeId) {
  return exchanges?.find(exchange => parseInt(exchange.eID) === parseInt(exchangeId)) || null;
}

export function getExchangeCodeById(exchanges, exchangeId) {
  return UiUtils.getExchangeCodeById(exchanges, exchangeId);
}

export function getExchangeCurrencyById(exchanges, exchangeId) {
  return UiUtils.getExchangeCurrencyById(exchanges, exchangeId);
}

export function getExchangeEquitiesValue({ stocks, indexedStocks, wallet, exchangeCode, currency }) {
  return UiUtils.extractExchangeEquitiesValue(stocks, indexedStocks, exchangeCode, currency, wallet);
}

export function getExchangeEquitiesAverageValue({ stocks, indexedStocks, wallet, exchangeCode, currency }) {
  return UiUtils.extractExchangeEquitiesAverageValue(stocks, indexedStocks, exchangeCode, currency, wallet);
}

export function getExchangePositionsCount(wallet, exchangeCode) {
  if (!wallet) {
    return 0;
  }

  return UiUtils.extractExchangePositionsCount(exchangeCode, wallet);
}

export function getExchangeSharesCount(wallet, exchangeCode) {
  if (!wallet) {
    return 0;
  }

  return UiUtils.extractExchangeEquitiesCount(exchangeCode, wallet);
}

export function getCurrencySharesCount(wallet, currency) {
  let totalShares = 0;
  wallet?.s?.forEach(item => {
    if (normalize(item.cc) === normalize(currency)) {
      totalShares += item.am;
    }
  });

  return totalShares;
}

export function getAllExchangeEquitiesValue({ stocks, indexedStocks, wallet, currency, exchangeCodes = WALLET_EXCHANGE_CODES }) {
  return exchangeCodes.reduce((total, exchangeCode) => {
    return total + parseFloat(getExchangeEquitiesValue({
      stocks,
      indexedStocks,
      wallet,
      exchangeCode,
      currency
    }));
  }, 0);
}

export function getStocksByExchangeCode(wallet, exchangeCode) {
  return wallet?.s?.filter(stock => normalize(stock.ex) === normalize(exchangeCode)) || [];
}

export function getExchangeSummaries({ currency, wallet, stocks, indexedStocks, selectedExchange, selectedExchangeCode }) {
  const currentCurrency = currency?.toUpperCase();
  const isExchangeVisible = currencyCode => {
    return (selectedExchange && currencyCode === selectedExchange.cc?.toUpperCase()) ||
      0 === parseInt(selectedExchangeCode);
  };

  return WALLET_EXCHANGE_SUMMARY_CONFIG.map(exchange => {
    const sharesCount = "EUR" === exchange.baseCurrency
      ? getCurrencySharesCount(wallet, "eur")
      : getExchangeSharesCount(wallet, exchange.code);

    return {
      id: exchange.id,
      code: exchange.code,
      title: exchange.title,
      logo: exchange.logo,
      baseCurrency: exchange.baseCurrency,
      sharesCount,
      visible: isExchangeVisible(exchange.visibleCurrency),
      avgValueInBgn: getExchangeEquitiesAverageValue({ stocks, indexedStocks, wallet, exchangeCode: exchange.code, currency: "bgn" }),
      avgValueInEur: getExchangeEquitiesAverageValue({ stocks, indexedStocks, wallet, exchangeCode: exchange.code, currency: "eur" }),
      positionsCount: getExchangePositionsCount(wallet, exchange.code),
      valueInBgn: getExchangeEquitiesValue({ stocks, indexedStocks, wallet, exchangeCode: exchange.code, currency: "bgn" }),
      valueInCurrentCurrency: getExchangeEquitiesValue({ stocks, indexedStocks, wallet, exchangeCode: exchange.code, currency: currentCurrency }),
      valueInEur: getExchangeEquitiesValue({ stocks, indexedStocks, wallet, exchangeCode: exchange.code, currency: "eur" })
    };
  });
}
